import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.array.index-of.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// hack 修复babel对Promise.then的polyfill未覆盖iterator的问题
// 如果项目用的corejs@2的话会报 Target is not iterable 的错误
import "core-js/modules/es.array.iterator";
import { request } from "../utils/ajax";
import BaseAdapter from "./BaseAdapter";
import { getShareMessage, urlFormatter, isZLJUrl, getPPU, formartChooseAddressRes } from "../utils/utils";
import { getCookie } from "../utils/cookies";
import { lego } from "../utils/lego";
import { setCookieOrigin } from "../utils/cookies";
import { platform } from "../platform/getCurrentPlatform";

var ZLJAdapter = /*#__PURE__*/function (_BaseAdapter) {
  _inherits(ZLJAdapter, _BaseAdapter);

  var _super = _createSuper(ZLJAdapter);

  function ZLJAdapter() {
    var _this;

    _classCallCheck(this, ZLJAdapter);

    return _this = _super.call(this, "https://s1.zhuanstatic.com/common/zlj-js-sdk/static/js/1.1.4/zlj-js-sdk.min.js", function () {
      _this.zlj = window.zlj;
      _this.__sdk = _this.zlj; // 转换同步的api为回调函数形式，保持zlj所有的api调用形式一致

      _this.transformAPI();
    });
  }

  _createClass(ZLJAdapter, [{
    key: "transformAPI",
    value: function transformAPI() {
      var _this2 = this;

      var API_LIST = ["getContextInfo", "checkThird", "checkLogin", "getSystemExtraInfo"];
      API_LIST.forEach(function (item) {
        var originFun = _this2.__sdk[item];

        _this2.__sdk[item] = function () {
          var argv = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var params = argv.params || [];

          if (!argv.success) {
            console.warn("找靓机APP中，getContextInfo,checkThird,checkLogin,getSystemExtraInfo五个方法进行了特殊处理，请调用这几个API时候，传入参数 { success: (res) => {console.log(res)} }， 在success回调中拿到结果");
          }

          var r = originFun.apply(_this2.__sdk, params);
          console.log(r);
          argv.success && argv.success(r);
        };
      });
    }
  }, {
    key: "getUserInfo",
    value: function getUserInfo(callback) {
      if (typeof callback !== 'function') {
        callback = callback.success;
      }

      callback && callback(this.zlj.getUserInfo());
    }
  }, {
    key: "setTitle",
    value: function setTitle(obj) {
      var title = obj.title;
      this.zlj.changeTitle(title);
    }
  }, {
    key: "share",
    value: function share(shareMessage, callback) {
      this.zlj.setShareInfo(Object.assign(getShareMessage(shareMessage), {
        type: 6,
        success: function success() {
          callback && callback({
            code: "0"
          });
        },
        fail: function fail() {
          callback && callback({
            code: "-1"
          });
        }
      }));
    }
  }, {
    key: "shareClick",
    value: function shareClick(shareMessage, callback) {
      this.zlj.showSharePanel(Object.assign(getShareMessage(shareMessage), {
        type: 6,
        success: function success() {
          callback && callback({
            code: 0
          });
        },
        fail: function fail() {
          callback && callback({
            code: -1
          });
        }
      }));
    }
  }, {
    key: "skipToUrl",
    value: function skipToUrl(obj) {
      var _this3 = this;

      var targetUrl = obj.targetUrl,
          _obj$needClose = obj.needClose,
          needClose = _obj$needClose === void 0 ? 0 : _obj$needClose;
      targetUrl = urlFormatter(targetUrl);
      needClose == 1 && this.zlj.setCloseMark({
        marks: location.href
      });

      if (isZLJUrl(targetUrl)) {
        location.href = targetUrl;
      } else {
        location.href = "zljgo://native_api?type=1&content=".concat(encodeURIComponent(targetUrl));
      }

      needClose == 1 && setTimeout(function () {
        _this3.zlj.closeByMarkArray({
          marks: [location.href]
        });
      }, 300);
    }
  }, {
    key: "login",
    value: function login(callback) {
      var _this4 = this;

      var skipSetPPU;

      if (_typeof(callback) === "object") {
        skipSetPPU = callback.skipSetPPU;
        callback = callback["callback"];
      }

      lego("PAGE_LOG_PPU", "LOGIN_START", {
        uid: getCookie("uid"),
        ppu: getCookie("PPU")
      });
      this.zlj.login({
        data: {
          dialog: "1"
        },
        success: function success(data) {
          lego("PAGE_LOG_PPU", "LOGIN_SUCCESS_0", {
            uid: getCookie("uid"),
            ppu: getCookie("PPU")
          });

          if (skipSetPPU) {
            return callback && callback(_objectSpread(_objectSpread({}, data), {}, {
              code: "0"
            }));
          }

          var token = data.token,
              userId = data.userId; // 如果token就是ppu格式，那么直接埋入即可

          if (token.indexOf("UID=") > -1 && document.domain.indexOf("zhuanzhuan.com") > -1) {
            lego("PAGE_LOG_PPU", "LOGIN_SUCCESS_1", {
              uid: getCookie("uid"),
              ppu: getCookie("PPU")
            });
            setCookieOrigin("uid", getPPU(token).UID);
            setCookieOrigin("PPU", "\"".concat(token, "\""));
            lego("PAGE_LOG_PPU", "LOGIN_SUCCESS_2", {
              uid: getCookie("uid"),
              ppu: getCookie("PPU")
            });
            callback && callback(_objectSpread(_objectSpread({}, data), {}, {
              code: "0"
            }));
            return;
          }

          var opts = {
            // url: 'https://kfimentry.zhuanzhuan.com/info/kfim/through/zljUserLogin',
            url: "https://app.zhuanzhuan.com/zzx/transfer/getPpuByZLJToken",
            method: "get",
            params: {
              zljToken: encodeURIComponent(token),
              zljUid: userId
            },
            csrfToken: false
          };
          lego("PAGE_LOG_PPU", "LOGIN_SUCCESS_3", {
            uid: getCookie("uid"),
            ppu: getCookie("PPU")
          });
          request(opts).then(function (res) {
            var _res$respData = res.respData,
                uid = _res$respData.uid,
                ppuStr = _res$respData.ppuStr;
            lego("PAGE_LOG_PPU", "LOGIN_SUCCESS_4", {
              uid: getCookie("uid"),
              ppu: getCookie("PPU"),
              res: res.respData
            });
            setCookieOrigin("uid", uid);
            setCookieOrigin("PPU", "\"".concat(ppuStr, "\""));
            callback && callback(_objectSpread(_objectSpread({}, data), {}, {
              code: "0"
            }));
          })["catch"](function (e) {
            lego("PAGE_LOG_PPU", "LOGIN_SUCCESS_5", {
              uid: getCookie("uid"),
              ppu: getCookie("PPU")
            });
            callback && callback({
              code: "-1"
            });

            _this4.zlj.logout();
          });
        },
        fail: function fail() {
          lego("PAGE_LOG_PPU", "LOGIN_FAIL", {
            uid: getCookie("uid"),
            ppu: getCookie("PPU")
          });
          callback && callback({
            code: "-1"
          });
        }
      });
    } // isLogin () {
    //   return this.zlj.checkLogin();
    // }

  }, {
    key: "close",
    value: function close() {
      this.zlj.closeWindow();
    }
  }, {
    key: "chooseAddress",
    value: function chooseAddress() {
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      var addressId = obj.addressId;
      this.zlj.chooseReceiveAddress({
        addressId: addressId || 0,
        success: function success(res) {
          try {
            callback && callback(formartChooseAddressRes(res));
          } catch (error) {
            console.log(error);
          }
        },
        fail: function fail(res) {
          callback && callback(res);
        }
      });
    }
  }, {
    key: "getQRCodeScan",
    value: function getQRCodeScan() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (args.length > 1) {
        this.zlj.qrCodeScan(function (res) {
          args[1]({
            code: res && res.qrCode ? "0" : -1,
            resultString: res.qrCode || "",
            resultStr: res.qrCode || "",
            msg: ""
          });
        });
      } else {
        this.zlj.qrCodeScan(function (res) {
          args[0]({
            code: res && res.qrCode ? "0" : -1,
            resultString: res.qrCode || "",
            resultStr: res.qrCode || "",
            msg: ""
          });
        });
      }
    }
  }, {
    key: "setPageBackAction",
    value: function setPageBackAction() {
      this.zlj.openBlockBack(true);
    }
  }, {
    key: "uploadPhotos",
    value: function uploadPhotos(obj, callback) {
      obj.maxAllowCount = obj.maxAllowCount || "5";
      this.zlj.uploadPhotos(obj, callback);
    }
  }]);

  return ZLJAdapter;
}(BaseAdapter);

export { ZLJAdapter as default };